<template>
  <div class="details">
    <form-title>基本信息</form-title>
    <info-panel :padding="24">
      <el-row>
        <el-col :span="col">
          <info-item label="真实姓名">
            {{ result.realName }}
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="学员电话">
            {{ result.mobilePhone }}
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="微信昵称">
            {{ result.wechatNickName }}
          </info-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="col">
          <info-item label="微信头像">
            <img
              class="avatar"
              :src="result.wechatAvatarUrl ? result.wechatAvatarUrl : avatarImg"
            >
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="地址">
            {{ result.address }}
          </info-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="col">
          <info-item label="身份证号">
            {{ result.idCard }}
          </info-item>
        </el-col>
      </el-row>
    </info-panel>
    <form-title>购买信息</form-title>
    <data-table
      :data="result.courseRegistrationList"
      :table-column="tableColumn"
      @buttonClick="buttonClick"
    />
  </div>
</template>
<script>
import infoPanel from '@/components/common/infoPanel.vue';
import infoItem from '@/components/common/infoItem.vue';
import formTitle from '@/components/common/formTitle.vue';
import dataTable from '@/components/common/dataTable.vue';
import axClient from '@/services';
import types, { courseTypeList, registrationStatusList } from '@/config';
import avatarImg from '@/assets/images/header/avatar.png';

export default {
  name: 'AccountDetails',
  components: {
    formTitle,
    infoPanel,
    infoItem,
    dataTable,
  },
  data() {
    return {
      types,
      avatarImg,
      col: 5,
      result: {
        courseRegistrationList: [],
      },
      tableColumn: [
        {
          key: 'courseName',
          label: '课程名',
          width: '120px',
          dataType: 'text',
        },
        {
          key: 'courseType',
          label: '课程类型',
          width: '160px',
          dataType: 'function',
          renderProps: '',
          render: (key) => courseTypeList.filter((item) => item.value === key),
        },
        {
          key: 'agencyName',
          label: '机构名称',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'payAmount',
          label: '支付金额',
          width: 'auto',
          dataType: 'money',
        },
        {
          key: 'refundAmount',
          label: '退款金额',
          width: 'auto',
          dataType: 'money',
        },
        {
          key: 'isRefund',
          label: '是否退款',
          width: '80px',
          dataType: 'component',
          renderProps: { 1: '是', 0: '否', successKey: 0 },
          render: () => 'status',
        },
        {
          key: 'registrationStatus',
          label: '状态',
          width: '160px',
          dataType: 'function',
          renderProps: '',
          render: (key) => registrationStatusList.filter((item) => item.value === key),
        },
        {
          key: 'createTime',
          label: '创建时间',
          width: '200px',
          dataType: 'time',
        },
        {
          key: 'control',
          label: '操作',
          width: '200px',
          dataType: 'component',
          renderProps: [
            {
              text: '一键完成学习进度条', renderKey: null, type: 'primary', eventIndex: 0, disableKey: null,
            },
          ],
          render: () => 'buttons',
        },
      ],
    };
  },
  computed: {
    agencyTabelData() {
      if (this.switchBtnKey && this.result) {
        return {
          list: this.result.agencyUserList,
        };
      }
      return { list: this.result.agencyCounselorList };
    },
  },
  created() {
    this.getInfo();
  },
  methods: {
    // table 传递过来的按钮点击
    buttonClick(type, item) {
      switch (type) {
        case 0:
          this.completeLiveWatch(item);
          break;
        default:
          break;
      }
    },
    // 详情
    async getInfo() {
      this.result = await axClient.student.getInfo(this.$route.params.id);
    },
    // 一键完成学习进度条
    async completeLiveWatch(item) {
      const data = await axClient.student.completeLiveWatch({ id: item.id });
      if (data) {
        this.$message.success('设置成功');
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.details {
  .title {
    margin-top: 12px;
  }
  .switch-btns {
    padding-bottom: 20px;
  }
}
</style>